// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14fLy","footer":"styles_footer__3SATD"};